import React from "react"
import { compose, withHooks, defaultProps } from "enhancers"
import { FormControlLabel, Radio } from "@material-ui/core"
import { RadioGroup as MuiRadioGroup } from "formik-material-ui"

import { ReactComponent as RadioUncheckedCircleIcon } from "assets/icon/radio_unchecked_circle_icon.svg"
import { ReactComponent as RadioCheckedCircleIcon } from "assets/icon/radio_checked_circle_icon_brown.svg"
import PropTypes from "prop-types"

const RadioGroup = ({ options, disabled, row, handleDeselect, deselected, ...rest }) => (
  <MuiRadioGroup {...rest} row={row}>
    {options.map((option) => (
      <FormControlLabel
        key={`${option.value}`}
        value={option.value}
        control={
          <Radio
            checked={rest.field.value === option.value}
            icon={<RadioUncheckedCircleIcon />}
            checkedIcon={<RadioCheckedCircleIcon />}
            disabled={disabled}
            onClick={() => (deselected ? handleDeselect(option.value) : null)}
          />
        }
        label={option.label}
        disabled={disabled}
      />
    ))}
  </MuiRadioGroup>
)

const enhancer = compose(
  defaultProps({
    options: [],
  }),
  withHooks((props, hooks) => {
    const { options, disabled, ...rest } = props
    const { useCallback, useEffect } = hooks

    const name = props.field.name
    const value = props.field.value
    const setFieldValue = props.form.setFieldValue
    const handleDeselect = useCallback(
      (selectedValue) => {
        if (value === selectedValue) {
          setFieldValue(name, null)
        }
      },
      [name, value, setFieldValue],
    )

    useEffect(() => {
      setFieldValue(name, value)
    }, [])

    console.log(value)

    return {
      options,
      disabled,
      handleDeselect,
      ...rest,
    }
  }),
)

RadioGroup.propTypes = {
  options: PropTypes.any.isRequired,
  disabled: PropTypes.any.isRequired,
  row: PropTypes.any.isRequired,
  handleDeselect: PropTypes.any.isRequired,
  deselected: PropTypes.any.isRequired,
}

export default enhancer(RadioGroup)
